import React from 'react'
import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import { alpha } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'

import { ChevronRight } from '@mxenabled/mx-icons'
import { CategoryIcon } from '@mxenabled/mxui'

import { ANALYTICS_EVENTS, ListItemRow, useEvent, useGlobalCopyStore } from '../../common'
import { type DetailedCategoryWithTransactions } from '../../core'

import { TRENDS_ANALYTICS_METADATA } from '../constants/TrendsWidget'
import { getCategoryColor } from '../../core/utils/CategoryUtil'
import { formatCurrency } from '../../core/utils/NumberFormatting'
interface CategoriesListItemProps extends DetailedCategoryWithTransactions {
  onClick?: () => void
  isLastItem?: boolean
  showDivider?: boolean
}

const CategoriesListItem = observer(
  ({
    totalAmount,
    guid,
    name,
    transactions,
    onClick,
    isLastItem = false,
    showDivider = true,
  }: CategoriesListItemProps) => {
    const { trends: copy } = useGlobalCopyStore()
    const { onEvent } = useEvent()
    const theme = useTheme()

    const transactionCountText = `${transactions.length} ${transactions.length === 1 ? copy.transaction : copy.transactions}`

    const handleClick = () => {
      onClick?.()
      onEvent(ANALYTICS_EVENTS.TRENDS_CLICK_LIST_ITEM, {
        ...TRENDS_ANALYTICS_METADATA,
        listItem: name,
      })
    }

    return (
      <React.Fragment key={guid}>
        <ListItemRow
          leftIcon={
            guid ? (
              <CategoryIcon
                categoryGuid={guid}
                sx={{
                  bgcolor: alpha(getCategoryColor(guid, theme), 0.15),
                  border: `1px solid ${getCategoryColor(guid, theme)}`,
                  color: 'text.primary',
                }}
              />
            ) : undefined
          }
          onClick={handleClick}
          rightContent={formatCurrency(Math.abs(totalAmount), '0,0.00')}
          rightIcon={onClick ? <ChevronRight /> : undefined}
          subtitle={transactionCountText}
          title={name}
        />
        {showDivider && <Divider component="li" sx={{ ml: isLastItem ? 24 : 68 }} />}
      </React.Fragment>
    )
  },
)

export default CategoriesListItem
